import MatchPlayPlayer from './match-play-player'

export default MatchPlayPlayer
